export var KEY_CODES;
(function (KEY_CODES) {
    KEY_CODES[KEY_CODES["Enter"] = 13] = "Enter";
    KEY_CODES[KEY_CODES["Spacebar"] = 32] = "Spacebar";
    KEY_CODES[KEY_CODES["ArrowUp"] = 38] = "ArrowUp";
    KEY_CODES[KEY_CODES["ArrowDown"] = 40] = "ArrowDown";
    KEY_CODES[KEY_CODES["ArrowRight"] = 39] = "ArrowRight";
    KEY_CODES[KEY_CODES["ArrowLeft"] = 37] = "ArrowLeft";
    KEY_CODES[KEY_CODES["Esc"] = 27] = "Esc";
})(KEY_CODES || (KEY_CODES = {}));
export var KEYS;
(function (KEYS) {
    KEYS["Enter"] = "Enter";
    KEYS["Spacebar"] = " ";
    KEYS["ArrowUp"] = "ArrowUp";
    KEYS["ArrowUpIE"] = "Up";
    KEYS["ArrowDown"] = "ArrowDown";
    KEYS["ArrowDownIE"] = "Down";
    KEYS["ArrowRight"] = "ArrowRight";
    KEYS["ArrowRightIE"] = "Right";
    KEYS["ArrowLeft"] = "ArrowLeft";
    KEYS["ArrowLeftIE"] = "Left";
    KEYS["Tab"] = "Tab";
    KEYS["Home"] = "Home";
    KEYS["End"] = "End";
    KEYS["Escape"] = "Escape";
})(KEYS || (KEYS = {}));
const getCorrectKeys = (event) => {
    if (event.which || event.keyCode) {
        return { keys: KEY_CODES, code: event.keyCode || event.which };
    }
    if (event.key) {
        return { keys: KEYS, code: event.key };
    }
    return undefined;
};
export function isSelectKey(event) {
    const { code, keys } = getCorrectKeys(event);
    switch (code) {
        case keys.Enter:
        case keys.Spacebar:
            return true;
        default:
            return false;
    }
}
//# sourceMappingURL=keyCodes.js.map